import { DEEPLINK_CONFIGS, DeepLinkConfig } from "./deepLinksConfigs";
import { getLogger } from "@flash-tecnologia/hros-telemetry";

const PATH_REGEXES = new Map<string, RegExp>();
const logger = getLogger(["hros-root", "deeplink"]);

function getPathRegex(pathPattern: string): RegExp {
  if (!PATH_REGEXES.has(pathPattern)) {
    const regex = pathPattern
      .replace(/:[^/]+/g, "[^/]+") // :param vira [^/]+
      .replace(/\//g, "\\/"); // escapa /
    PATH_REGEXES.set(pathPattern, new RegExp(`^${regex}$`));
  }
  return PATH_REGEXES.get(pathPattern)!;
}

function extractPathParams(pathname: string, pathPattern: string): Record<string, string> {
  const pathParams: Record<string, string> = {};

  const patternSegments = pathPattern.split("/").filter(Boolean);
  const pathSegments = pathname.split("/").filter(Boolean);

  patternSegments.forEach((segment, index) => {
    if (segment.startsWith(":")) {
      const paramName = segment.slice(1);
      const paramValue = pathSegments[index];
      if (paramValue) {
        pathParams[paramName] = paramValue;
      }
    }
  });

  return pathParams;
}

/**
 * Gera URL de deeplink genérica baseada na configuração
 * @param pathname - Caminho atual da URL web (ex: /document-management/employee/123)
 * @param searchParams - Query parameters da URL web
 * @param config - Configuração de deeplink correspondente
 * @returns URL completa do deeplink
 */
function generateDeepLinkUrl(
  pathname: string,
  searchParams: URLSearchParams,
  config: DeepLinkConfig,
): string {
  const baseUrl =
    process.env.STAGE === "staging" || process.env.NODE_ENV === "development"
      ? "br.com.flashapp.staging://deeplink"
      : "br.com.flashapp://deeplink";

  const pathParams = extractPathParams(pathname, config.path);

  const paramsToExtract = config.deeplinkSearchParams || [];
  const relevantParams = new URLSearchParams();

  paramsToExtract.forEach((param) => {
    const value = pathParams[param] ?? searchParams.get(param);
    if (value) {
      relevantParams.set(param, value);
    }
  });

  let deepLinkPath = config.deeplinkPath;
  Object.entries(pathParams).forEach(([key, value]) => {
    deepLinkPath = deepLinkPath.replace(`:${key}`, value);
  });

  let deepLinkUrl = `${baseUrl}${deepLinkPath}`;

  const paramString = relevantParams.toString();
  if (paramString) {
    deepLinkUrl += `?${paramString}`;
  }

  return deepLinkUrl;
}

export function checkAndRedirectToMobileDeepLink(): void {
  const isMobileDevice =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
      navigator.userAgent,
    );
  if (!isMobileDevice) return;

  const currentUrl = new URL(window.location.href);
  const pathname = currentUrl.pathname;
  const searchParams = currentUrl.searchParams;

  const matchingConfig = DEEPLINK_CONFIGS.find((config) =>
    getPathRegex(config.path).test(pathname),
  );

  if (!matchingConfig) {
    return;
  }

  try {
    const deepLinkUrl = generateDeepLinkUrl(pathname, searchParams, matchingConfig);
    window.location.href = deepLinkUrl;
    return;
  } catch (error) {
    logger.error("Erro ao redirecionar para o deeplink", { error });
    return;
  }
}
